import { useMemo } from 'react';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import useRemoteDataFetcher from '../../../../hooks/generic/PageUI/useRemoteDataFetcher';
import { DEFAULT_SILO_BUSTING_CHART_DATA } from './utils';

const useSiloBustingDataFetcher = ({ 
  selectedConnectionView, 
  selectedProfileQuestion, 
  url 
}) => {
  // Remote data fetcher for API calls
  const shouldFetchData = selectedConnectionView && selectedProfileQuestion;
  
  const urlOptions = useMemo(() => {
    if (!shouldFetchData) return {};
    return {
      filters: {
        connection_view_id: selectedConnectionView.value,
        profile_question_id: selectedProfileQuestion.value,
        fetch_only_chart_data: true
      }
    };
  }, [selectedConnectionView, selectedProfileQuestion, shouldFetchData]);

  const { remoteData, contentLoaded } = useRemoteDataFetcher({
    remoteOptions: {
      url: url,
      urlOptions: urlOptions
    },
    dependencies: [urlOptions],
    fetchCondition: () => shouldFetchData,
    fetchOnlyOnce: false
  });

  // Use API data if available, otherwise fall back to empty data
  const chartComponentData = useMemo(() => {
    if (shouldFetchData && contentLoaded && remoteData?.metrics) {
      const networkMetric = getMetricDataFromArray(remoteData.metrics, MetricUId.SILO_BUSTING_CHART_DATA);
      return networkMetric?.data?.value || DEFAULT_SILO_BUSTING_CHART_DATA;
    }
    return DEFAULT_SILO_BUSTING_CHART_DATA;
  }, [remoteData, contentLoaded, shouldFetchData]);

  // Show loader when fetching data
  const isLoading = shouldFetchData && !contentLoaded;

  return {
    chartComponentData,
    isLoading,
    contentLoaded,
    remoteData
  };
};

export default useSiloBustingDataFetcher;